<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
.map-img {
  width: 100%;
  height: auto;
  border: 0;
  margin-top: 10px;
}


</style>

<template>
    <div>
      <img  class="map-img" src="../../../public/image/internet_conference_build_a.png" @click="getImg(0)"/>
      
    </div>

</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { ImagePreview } from 'vant';



export default defineComponent({
    name: "InternetConference",

    methods: {
      getImg(index) {
        ImagePreview({
          images:["../../image/internet_conference_build_a.png"],
          showIndex: true,
          loop: false,
          startPosition:index
          })
      }
    }
})
</script>



